import { Post } from '../helpers';

const GreenroomLogin = (): Promise<{ token: string }> => {
  return Post({ path: `/v2/greenroom/producer/login/streams` });
};

export default GreenroomLogin;
